import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { networkRequest } from '@tencent/ark-request';
import { isImageLike } from '@tencent/docs-mime-types';
import { getXsrfToken } from "../cgi/cookies";
import { DEFAULT_CREATOR_DOMAIN, DEFAULT_DOMAIN_ID, DocPolicy, DocSource, DocStatus, DRIVE_FILE_KIND, DriveFileType } from "../model/drive-file";
import { Backend } from "../types/backend";

/** 这个值的作用是私有化并不是所有图片都能预览，目前能否预览的配置维护在后台，通过thumbnailUrl是否为空而告知前端 */
var judgeIfFileCanBeLoadedByDriveEngine = function judgeIfFileCanBeLoadedByDriveEngine(mimeType, thumbnailUrl) {
  return !isImageLike(mimeType) || Boolean(thumbnailUrl);
};

// fileInfo 接口数据 → DriveFile 模型数据
// eslint-disable-next-line max-lines-per-function
export function fromFileInfoResp(resp) {
  var _resp$result, _fileMeta$cosInfo, _DriveFileType$CLOUD$, _fileMeta$cosInfo2, _privilege$policy, _fileMeta$status, _fileMeta$thumbnailUr, _fileMeta$tencentDocU;
  var result = (_resp$result = resp === null || resp === void 0 ? void 0 : resp.result) !== null && _resp$result !== void 0 ? _resp$result : resp;
  var fileMeta = result.fileMeta,
    docInfo = result.docInfo,
    privilege = result.privilege,
    mimeType = result.mimeType,
    owner = result.owner,
    operator = result.operator;

  // 现阶段通过 fileId 存在与否判断附件还是云文件
  var driveFileType = fileMeta.fileId ? DriveFileType.CLOUD : DriveFileType.ATTACHMENT;
  return {
    canLoadDriveEngine: judgeIfFileCanBeLoadedByDriveEngine(mimeType, fileMeta.thumbnailUrl),
    isTrashed: docInfo.docStatus === DocStatus.MovedToTrash,
    driveFileType: driveFileType,
    // @ts-ignore
    id: (_DriveFileType$CLOUD$ = {}, _defineProperty(_DriveFileType$CLOUD$, DriveFileType.CLOUD, fileMeta.fileId), _defineProperty(_DriveFileType$CLOUD$, DriveFileType.ATTACHMENT, fileMeta === null || fileMeta === void 0 ? void 0 : (_fileMeta$cosInfo = fileMeta.cosInfo) === null || _fileMeta$cosInfo === void 0 ? void 0 : _fileMeta$cosInfo.cosId), _DriveFileType$CLOUD$)[driveFileType] || '',
    hostId: fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.hostFileId,
    kind: DRIVE_FILE_KIND,
    // 云编的文件后台会返回tencentdoc，这是为了品类详情页打开使用。而drive侧需要的是drive文件的后缀，因此从cosInfo中取。
    // 这里存量的数据会返回 driveExt: "" 用 【??】会返回"" 而不会返回fileMeta.ext
    ext: ((_fileMeta$cosInfo2 = fileMeta.cosInfo) === null || _fileMeta$cosInfo2 === void 0 ? void 0 : _fileMeta$cosInfo2.driveExt) || fileMeta.ext,
    cosInfo: fileMeta.cosInfo,
    creatorDomainId: docInfo.creatorDomain || DEFAULT_CREATOR_DOMAIN,
    domainId: docInfo.domainId || DEFAULT_DOMAIN_ID,
    clientId: fileMeta.clientId || null,
    groupChatKey: '',
    // 待确认
    groupName: '',
    // 待确认
    isCollected: false,
    // 待确认
    isPinned: null,
    // 待确认
    lastCollectTs: 0,
    // 待确认
    lastPinnedTs: 0,
    // 待确认
    officialAuthInfo: null,
    // 待确认,
    personalizeInfo: null,
    // 待确认
    previewInfo: null,
    // 待确认
    auditStatus: null,
    // 待确认
    size: Number(fileMeta.size),
    operator: operator,
    privilege: {
      isAuth: privilege.attribute.isAuth,
      canCopy: privilege.attribute.canCopy,
      canPrint: privilege.attribute.canPrint,
      canRead: privilege.attribute.canRead,
      canReadRevisions: privilege.attribute.canHistory,
      canRename: privilege.attribute.canEditTitle,
      canSearchContent: privilege.attribute.canSearch,
      canAddUser: privilege.attribute.canAddUser,
      canViewImage: privilege.attribute.canViewImage,
      canEdit: privilege.attribute.canEdit,
      canShare: privilege.attribute.canShare,
      canComment: privilege.attribute.canComment,
      canAbout: privilege.attribute.canAbout,
      canSpitSlot: privilege.attribute.canSpitSlot,
      canSetWatermark: privilege.attribute.canWatermark,
      canUseTranslate: privilege.attribute.canTranslate,
      canSetLinkExp: privilege.attribute.canLinkExp,
      canCopyFile: privilege.attribute.canCopyDoc,
      canPublish: privilege.attribute.canPublish,
      canSetRange: privilege.attribute.canSetRange,
      canEditTab: privilege.attribute.canEditTab,
      canExport: privilege.attribute.canExport,
      canApplyEditPermission: privilege.attribute.canApplyEditPermission,
      canSaveAsTemplate: privilege.attribute.canSaveAsTemplate,
      policy: privilege.policy,
      privilegeFlag: privilege.privilegeFlag
    },
    properties: {},
    policy: (_privilege$policy = privilege.policy) !== null && _privilege$policy !== void 0 ? _privilege$policy : DocPolicy.Private,
    source: DocSource.Personal,
    // 待确认
    status: (_fileMeta$status = fileMeta.status) !== null && _fileMeta$status !== void 0 ? _fileMeta$status : DocStatus.Normal,
    // 待确认, 应该是这个
    tenantId: fileMeta.tenantId || null,
    // 空字符串 fallback 到 null
    thumbnailUrl: (_fileMeta$thumbnailUr = fileMeta.thumbnailUrl) !== null && _fileMeta$thumbnailUr !== void 0 ? _fileMeta$thumbnailUr : '',
    url: (_fileMeta$tencentDocU = fileMeta.tencentDocUrl) !== null && _fileMeta$tencentDocU !== void 0 ? _fileMeta$tencentDocU : '',
    weDriveInfo: null,
    // 待确认

    title: fileMeta.name,
    // 待确认, 是 fileMeta.name 吧 ?
    addToListTs: 0,
    // 待确认
    collaborationFlag: fileMeta.collaborationFlag,
    createTs: Number(fileMeta.createTime),
    // 这是一个写成字符串的数字
    creator: {
      uid: fileMeta.creator,
      nick: '' // 待确认, 没有看到有 creator 的名字
    },

    docType: 101,
    // 待确认, drive doc type
    iconUrl: fileMeta.iconUrl || '',
    lastBrowseTs: 0,
    // 待确认
    lastDeleteTs: 0,
    // 待确认
    lastModifyTs: Number(fileMeta.modifyTime),
    lastModifier: {
      uid: '',
      // 待确认
      nick: '' // 待确认
    },

    mimeType: mimeType,
    owner: {
      uid: fileMeta.owner,
      nick: owner.nick,
      avatarFrameUrl: '',
      // 待确认
      expiredStatus: 0,
      // 待确认
      vipLevel: 0,
      // 待确认
      renewalStatus: 0 // 待确认
    },

    originParentId: null,
    // 待确认
    parentId: fileMeta.fileParentId,
    // 不使用后台返回的 parentId，避免和 SpecialFolderId 混淆
    thirdAppId: null,
    // 待确认
    isOwnedByMe: docInfo.isOwner // 待确认, 应该是这个
  };
}

export function fetchFileInfo(_x) {
  return _fetchFileInfo.apply(this, arguments);
}
function _fetchFileInfo() {
  _fetchFileInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(req) {
    var xsrf, data, resp;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          xsrf = getXsrfToken();
          data = {
            file_id: req.fileId,
            xsrf: xsrf
          };
          if (req.objKey) data.obj_key = req.objKey;
          _context.next = 5;
          return networkRequest.request({
            url: "/v2/drive/fileInfo?xsrf=".concat(xsrf),
            method: 'POST',
            data: data
          });
        case 5:
          resp = _context.sent;
          return _context.abrupt("return", resp.data);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchFileInfo.apply(this, arguments);
}
export function fetchDriveFile(_x2) {
  return _fetchDriveFile.apply(this, arguments);
}

/**
 * 用于判断是否已经使用 {@link fromFileInfoResp} 转换过的 fileInfo
 * 后台 fileInfo 接口回来的是没有 driveFileType 字段
 */
function _fetchDriveFile() {
  _fetchDriveFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(req) {
    var resp, error;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetchFileInfo(req);
        case 2:
          resp = _context2.sent;
          if (!(resp.retcode !== Backend.RetCode.SUCCESS)) {
            _context2.next = 7;
            break;
          }
          error = new Error('请求 fileInfo 接口失败'); // @ts-ignore;
          error.data = resp;
          throw error;
        case 7:
          return _context2.abrupt("return", fromFileInfoResp(resp));
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchDriveFile.apply(this, arguments);
}
export function isTransformDriveFile(driveFile) {
  return !!(driveFile !== null && driveFile !== void 0 && driveFile.driveFileType);
}
//# sourceMappingURL=file-info.js.map